// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: '6108e71f-736a-4a18-8859-b52654931d6a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'eca46b7d-8665-486e-a479-87904cb982b8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 266,
      y: 118,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      mask: null,
      parent: '6108e71f-736a-4a18-8859-b52654931d6a'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.4',
  handleResize: false
} as const;

export class Test2 {
  static raw = raw;
  root!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
